/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Code_SubmittingInputs */

const en_us2_auth_code_submitting = /** @type {(inputs: Auth_Code_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing in…`)
};

const pt_br2_auth_code_submitting = /** @type {(inputs: Auth_Code_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrando…`)
};

const es_419_auth_code_submitting = /** @type {(inputs: Auth_Code_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrando…`)
};

const pt_pt2_auth_code_submitting = /** @type {(inputs: Auth_Code_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A entrar…`)
};

const fr_fr2_auth_code_submitting = /** @type {(inputs: Auth_Code_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion…`)
};

const de_de2_auth_code_submitting = /** @type {(inputs: Auth_Code_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldung…`)
};

const it_it2_auth_code_submitting = /** @type {(inputs: Auth_Code_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesso…`)
};

/**
* | output |
* | --- |
* | "Signing in…" |
*
* @param {Auth_Code_SubmittingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_code_submitting = /** @type {((inputs?: Auth_Code_SubmittingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Code_SubmittingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_code_submitting(inputs)
	if (locale === "es-419") return es_419_auth_code_submitting(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_code_submitting(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_code_submitting(inputs)
	if (locale === "de-DE") return de_de2_auth_code_submitting(inputs)
	if (locale === "it-IT") return it_it2_auth_code_submitting(inputs)
	return en_us2_auth_code_submitting(inputs)
});
export { auth_code_submitting as "auth.code_submitting" }